module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD4AAAAOCAYAAAB3u6/pAAAAAXNSR0IArs4c6QAAATdJREFUSA3dV6ESwjAMbWowINHjDiw/wc0y/gEUns/Ao+AjhuX4CewE00gwqJLs2l3pja3hEDlquqYvb3ld16SgvHbbZ4PH02xAQYbmiZ0qjDJ5vwfb4Sq/e3D2oyR+cNFfd/OZMeqA48TZgr4EUMvR+ngO7FFDafyVcAoKoz+h8HohmtSgcIP2lCteIj/Y7XdBQZ++dLgGJW77aey2l8qv6Z9miKZFSKxPuCCNY6n8Gjf3ojHiFqM9/FoQ3pRQfg0Gxl6YsY/uxO/ES+XXnZH/KYCEF19o4/hwsC4Ujg8HW/NrKk7cKLbn+HCw7v0cHw7W59dUkaGhdMaIntIZ+UQ1qfya8jFVZLY4aRVDGMLG5nAik8pfHW62EksxzrYvT3Psqo3ES+R/K1HdJYJyu5eGfn5JkcD/AluW9MHSOLbqAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/getmore.png
// module id = 7aEc
// module chunks = 3